import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchSessionSummary } from '@/api/sessionSummaries/sessionSummariesApi';
import type { SessionSummary } from '@/api/sessionSummaries/sessionSummariesApi.types';
import { buildSessionSummaryQueryKey } from '@/constants/queryKeys';

export function useSessionSummaryQuery(noteId: string): UseQueryResult<SessionSummary, Error> {
  return useQuery({
    queryKey: buildSessionSummaryQueryKey(noteId),
    queryFn: function loadSummary() {
      return fetchSessionSummary(noteId);
    },
    enabled: noteId.length > 0,
  });
}
